import { render } from "./FormEditKid.vue?vue&type=template&id=6b1f45d7&scoped=true"
import script from "./FormEditKid.vue?vue&type=script&lang=js"
export * from "./FormEditKid.vue?vue&type=script&lang=js"

import "./FormEditKid.vue?vue&type=style&index=0&id=6b1f45d7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue-soft/vue-soft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1f45d7"]])

export default __exports__